import React from 'react';
import { steps } from '../data/judo';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-170" data-mp="7svhkqze2gze">
      <div className="mx-auto max-w-6xl" data-id="element-171" data-mp="3pyrn6uxq0m9i">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-172" data-mp="3pzt9xwo3mx72">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-173" data-mp="3tzjwfo6ler5s">
            Jak działa <em className="text-red-700" data-id="element-174" data-mp="lll5x22e3xzo">JUDO GOTOWE™</em>
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-175" data-mp="qjmkpass9b5c">
            Od pobrania do maty: przygotuj kolejne zajęcia w zaledwie pięć minut.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-176" data-mp="gt1o1swo6gp2">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-177" data-mp="14ivyy4xfhv6o" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-178" data-mp="19ae4z7eb6lyi">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-179" data-mp="2rjlaz1qhh9xd">
                <span className="sr-only" data-id="element-180" data-mp="2mo5vy6gqp7zd">Krok {index + 1}: </span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-181" data-mp="31dkaru334hm5">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-182" data-mp="2wixupdm260vq">
          Otwórz → wybierz → wydrukuj → wejdź na matę. Prosto i przejrzyście.
        </p>
      </div>
    </section>;
}